import { render, staticRenderFns } from "./reconcilated-record-list.vue?vue&type=template&id=24354934&"
import script from "./reconcilated-record-list.vue?vue&type=script&lang=js&"
export * from "./reconcilated-record-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports